/**
 * @generated SignedSource<<c7db569b8fe44ba79259b2369f627dbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedPrintDetailsLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetails_item">;
  readonly " $fragmentType": "PdpRespSharedPrintDetailsLazy_item";
};
export type PdpRespSharedPrintDetailsLazy_item$key = {
  readonly " $data"?: PdpRespSharedPrintDetailsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetailsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedPrintDetailsLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "35c06f1cf4e589dae50bde8ae29b4902";

export default node;
